
import { mapState, mapGetters } from 'vuex'
import cms from '~/mixins/common/cms'
export default {
    mixins: [cms],
    data() {
        return {
            route: '/',
        }
    },
    computed: {
        ...mapState({
            isLogin: (state) => state.settings.isLogin,
            footerCmsLoading: (state) => state.cms.footerCmsLoading,
        }),
        ...mapGetters({
            mobileGameWheelIcon: 'cms/mobileGameWheelIcon',
        }),
    },
    watch: {
        '$nuxt.$route.path'(value) {
            this.route = value
        },
    },
    mounted() {
        this.route = this.$nuxt.$route.path
    },
    methods: {
        isActive(route) {
            return this.route === route
        },
    },
}
